import { useCallback, useState } from 'react';

export default function useToggleState(initialValue) {
  const [state, setState] = useState(initialValue || false);

  const toggleState = useCallback(() => {
    setState(!state);
  }, [state]);

  function toggleOn() {
    setState(true);
  }

  function toggleOff() {
    setState(false);
  }

  return { isToggled: state, toggleState, toggleOn, toggleOff };
}



// WEBPACK FOOTER //
// ./src/components/autolink_textarea/use_toggle.js